"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".full-width[_ngcontent-%COMP%]{width:100%}.registration-card[_ngcontent-%COMP%]{min-width:320px;max-width:500px;margin:20px auto}.mat-radio-button[_ngcontent-%COMP%]{display:block;margin:5px 0}.mat-divider[_ngcontent-%COMP%]{display:block;margin:0;border-top:2px solid #ff69b4}.disclaimer[_ngcontent-%COMP%]{border:1px solid #757575;max-height:100px;overflow-y:scroll}.registration__loader[_ngcontent-%COMP%]{display:flex;justify-content:center;margin:15px 0}\n/*# sourceMappingURL=register.component.css.map*/"];
exports.styles = styles;
